import { useState } from 'react'

interface OtpGateProps {
  attemptsLeft: number
  errorMsg: string | null
  onSubmit: (otp: string) => void
}

export function OtpGate({ attemptsLeft, errorMsg, onSubmit }: OtpGateProps) {
  const [val, setVal] = useState('')

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!/^\d{6}$/.test(val)) return
    onSubmit(val)
  }

  return (
    <form className="public-response-card" onSubmit={handleSubmit}>
      <h1>Access code required</h1>
      <p>Open the email titled <strong>&ldquo;Access code for your coding query&rdquo;</strong> and enter the 6-digit code below.</p>

      <input
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        value={val}
        onChange={(e) => setVal(e.target.value.replace(/\D/g, '').slice(0, 6))}
        placeholder="123 456"
        className="public-response-otp-input"
        aria-label="Six-digit access code"
        autoFocus
      />

      {errorMsg && <div className="public-response-error">{errorMsg}</div>}
      {attemptsLeft < 5 && attemptsLeft > 0 && (
        <p style={{ fontSize: 12, color: '#92400e' }}>{attemptsLeft} attempt{attemptsLeft === 1 ? '' : 's'} remaining.</p>
      )}

      <button type="submit" className="public-response-submit" disabled={val.length !== 6}>
        Verify code
      </button>
    </form>
  )
}
